import React from 'react';
import {
  Bars3BottomLeftIcon,
  PhotoIcon,
  PlayIcon,
  ChatBubbleBottomCenterTextIcon,
  CodeBracketIcon,
  CodeBracketSquareIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const BLOCK_TYPES = [
  {
    type: 'h2',
    label: 'Heading',
    description: 'Large section heading',
    icon: () => (
      <span className="text-lg font-bold">H2</span>
    )
  },
  {
    type: 'h3',
    label: 'Subheading',
    description: 'Smaller section heading',
    icon: () => (
      <span className="text-base font-bold">H3</span>
    )
  },
  {
    type: 'paragraph',
    label: 'Paragraph',
    description: 'Plain text block',
    icon: Bars3BottomLeftIcon
  },
  {
    type: 'image',
    label: 'Image',
    description: 'Upload or embed an image',
    icon: PhotoIcon
  },
  {
    type: 'video',
    label: 'Video',
    description: 'Embed YouTube or Vimeo',
    icon: PlayIcon
  },
  {
    type: 'blockquote',
    label: 'Quote',
    description: 'Highlighted quote block',
    icon: ChatBubbleBottomCenterTextIcon
  },
  {
    type: 'code',
    label: 'Code',
    description: 'Code snippet with syntax',
    icon: CodeBracketIcon
  },
  {
    type: 'embed',
    label: 'Embed',
    description: 'Paste iframe embed code',
    icon: CodeBracketSquareIcon
  }
];

const BlockToolbar = ({ onAddBlock, onClose, inline = false }) => {
  const containerClass = inline
    ? 'flex flex-wrap gap-2 justify-center'
    : 'bg-white border border-gray-200 rounded-lg shadow-lg p-4';

  return (
    <div className={containerClass}>
      {!inline && (
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-medium text-gray-700">Add Block</span>
          <button
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-gray-600 rounded"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
      )}
      
      <div className={inline ? 'flex flex-wrap gap-2 justify-center' : 'grid grid-cols-2 gap-2'}>
        {BLOCK_TYPES.map((block) => {
          const Icon = block.icon;
          return (
            <button
              key={block.type}
              onClick={() => onAddBlock(block.type)}
              className={`flex items-center gap-2 p-2 rounded-lg border border-gray-200 hover:border-primary-400 hover:bg-primary-50 transition-colors text-left ${
                inline ? 'px-3' : 'w-full'
              }`}
            >
              <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded text-gray-600">
                <Icon className="w-5 h-5" />
              </div>
              <div className={inline ? '' : 'flex-1'}>
                <div className="text-sm font-medium text-gray-900">{block.label}</div>
                {!inline && (
                  <div className="text-xs text-gray-500">{block.description}</div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BlockToolbar;
